import _slicedToArray from "@babel/runtime/helpers/slicedToArray";
import React, { useEffect, useMemo } from 'react';
import { RemoveIcon, SquareReturnIcon } from '../icons';
import { messages } from '../messages';
import { FormattedMessage } from 'react-intl-next';
import { enrichResultTitle } from '@atlassian/search-common';
import { IconButton } from '@atlaskit/button/new';
import { CollapsedResultContentWrapper, EnlargedCollapsedResultDetail, EnlargedCollapsedResultDetailWrapper, EnlargedIconContainer, EnlargedResultDetail, EnlargedResultContentWrapper, ResultLabel, EnlargedResultTitleContainer, EnlargedReturnIconContainer } from './search-result.styled';

/**
 * This component is an alternative to the default result content component.
 * It displays the result content in a taller component. It displays the metadata underneath
 * the title, and show the additional metadata on the right.
 */
export var EnlargedSearchResultContent = function EnlargedSearchResultContent(_ref) {
  var icon = _ref.icon,
    label = _ref.label,
    title = _ref.title,
    highlightedTitle = _ref.highlightedTitle,
    meta = _ref.meta,
    additionalMeta = _ref.additionalMeta,
    displayAdditionalMetaWhenHighlightedOnly = _ref.displayAdditionalMetaWhenHighlightedOnly,
    isCollapsed = _ref.isCollapsed,
    isKeyboardHighlighted = _ref.isKeyboardHighlighted,
    _ref$returnIcon = _ref.returnIcon,
    returnIcon = _ref$returnIcon === void 0 ? 'onHighlight' : _ref$returnIcon,
    isRecentSearch = _ref.isRecentSearch,
    onRemove = _ref.onRemove;
  var contentRef = React.useRef(null);
  var _React$useState = React.useState(false),
    _React$useState2 = _slicedToArray(_React$useState, 2),
    isHover = _React$useState2[0],
    setIsHover = _React$useState2[1];
  var isActive = isKeyboardHighlighted || isHover;
  var showReturnIcon = useMemo(function () {
    return (returnIcon === 'always' || returnIcon === 'onHighlight' && isKeyboardHighlighted) && !isRecentSearch;
  }, [isKeyboardHighlighted, returnIcon, isRecentSearch]);
  var showRemoveIcon = useMemo(function () {
    return isRecentSearch && isActive;
  }, [isRecentSearch, isActive]);
  var showAdditionalMeta = useMemo(function () {
    return additionalMeta && (!displayAdditionalMetaWhenHighlightedOnly || isActive);
  }, [displayAdditionalMetaWhenHighlightedOnly, isActive, additionalMeta]);
  useEffect(function () {
    var _contentRef$current;
    if (isKeyboardHighlighted && (_contentRef$current = contentRef.current) !== null && _contentRef$current !== void 0 && _contentRef$current.scrollIntoView) {
      contentRef.current.scrollIntoView({
        behavior: 'auto',
        block: 'nearest'
      });
    }
  }, [isKeyboardHighlighted]);
  return /*#__PURE__*/React.createElement(EnlargedResultContentWrapper, {
    ref: contentRef,
    isCollapsed: isCollapsed,
    isKeyboardHighlighted: isKeyboardHighlighted,
    onMouseEnter: function onMouseEnter() {
      return setIsHover(true);
    },
    onMouseLeave: function onMouseLeave() {
      return setIsHover(false);
    }
  }, /*#__PURE__*/React.createElement(EnlargedIconContainer, null, icon), /*#__PURE__*/React.createElement(CollapsedResultContentWrapper, {
    "data-testid": "collapsed-result-view"
  }, /*#__PURE__*/React.createElement(EnlargedResultTitleContainer, {
    isCollapsed: true
  }, typeof title === 'string' ? /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement("span", {
    title: title,
    className: "SearchDialogResultTitle"
  }, highlightedTitle ? enrichResultTitle(highlightedTitle) : title)) : title, typeof label === 'string' ? /*#__PURE__*/React.createElement(ResultLabel, {
    title: label
  }, label) : label), meta && /*#__PURE__*/React.createElement(EnlargedCollapsedResultDetailWrapper, null, /*#__PURE__*/React.createElement(EnlargedCollapsedResultDetail, null, meta))), showAdditionalMeta && /*#__PURE__*/React.createElement(EnlargedResultDetail, null, additionalMeta), showReturnIcon && /*#__PURE__*/React.createElement(EnlargedReturnIconContainer, null, /*#__PURE__*/React.createElement(SquareReturnIcon, null)), showRemoveIcon && /*#__PURE__*/React.createElement(EnlargedReturnIconContainer, null, /*#__PURE__*/React.createElement(IconButton, {
    icon: RemoveIcon,
    spacing: 'compact',
    onClick: onRemove,
    label: /*#__PURE__*/React.createElement(FormattedMessage, messages.remove_button_label),
    appearance: 'subtle'
  })));
};